import React from 'react'
// import BsFacebook from 'react-icons/bf'

const Contact = () => {
  return (
    <div>
      <section className='max-w-[1240px bg-gray-300 p-5 h-[600px]  grid grid-cols-1 md:grid-cols-2 gap-5'>
      <div className='mx-5 cols-span-1 '>

      <div className='px-2  shadow-pink-300 shadow-lg py-4'>
      <h1 className='text-blue-500 capitalize py-5 text-xl md:text-3xl'>Contact us For Info</h1>
      <h3 className='text-xl bg-slate-500 p-2 rounded-xl shadow-lg shadow-green-400 my-5'>Gmail: <span>Imranuu@gmail.com</span></h3>
      <h3 className='text-xl bg-slate-500 p-2 rounded-xl shadow-lg shadow-green-400 my-5'>Mobile Call: <span>03369756177</span></h3>
      <h3 className='text-xl bg-slate-500 p-2 rounded-xl shadow-lg shadow-green-400 my-5'>Whatsapp: <span>00923410704891</span></h3>
      </div>

        
      </div>
      <div className="cols-span-1">
      <h1 className='text-xl md:text-3xl text-black font-serif py-10'>Follow us On | Social Media</h1>
        <ul>
            <li className='text-2xl text-blue-600 py-2'>Facebook</li>
            <li className='text-2xl text-blue-600 py-2'>Twitter</li>
            <li className='text-2xl text-blue-600 py-2'>Instagram</li>
        </ul>
      </div>
      </section>
    </div>
  )
}

export default Contact